// Property type factories used to build appearance editors
import { StrokeType, FontType, FillType, BooleanType } from "../PropertyTypes";

// Linhas (Lines) category - includes trend lines and basic line drawing tools
const linhasRegistry = {
  displayName: "Linhas",
  interactives: {
    trendLine: {
      displayName: "Trend Line",
      key: "trendLine",
      icon: "Trend_Line",
      propName: "trends",
      component: "TrendLine",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FontType({
          name: "labelFont",
          displayName: "Fonte do Rótulo",
          defaultValue: {
            fontFamily: "system-ui, -apple-system, sans-serif",
            color: "#ffffff",
            fontSize: 12,
          },
        }),
      ],
    },
    ray: {
      displayName: "Ray",
      key: "ray",
      icon: "LineSans_Ray",
      propName: "rays",
      component: "Ray",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    horizontalLine: {
      displayName: "Linha Horizontal",
      key: "horizontalLine",
      icon: "LineSans_Horizontal",
      propName: "horizontalLines",
      component: "HorizontalLine",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    verticalLine: {
      displayName: "Linha Vertical",
      key: "verticalLine",
      icon: "LineSans_Vertical",
      propName: "verticalLines",
      component: "VerticalLine",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    line: {
      displayName: "Linha Infinita",
      key: "line",
      icon: "LineSans",
      propName: "lines",
      component: "Line",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    segment: {
      displayName: "Segmento",
      key: "segment",
      icon: "LineSans_Segment",
      propName: "segments",
      component: "Segment",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    continuous: {
      displayName: "Contínuo",
      key: "continuous",
      icon: "LineSans_Continuouos", // Typo no arquivo SVG original
      propName: "segments", // Reutiliza o array de segments
      component: "Continuous",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    averageLine: {
      displayName: "Linha Média",
      key: "averageLine",
      icon: "Average_Line",
      propName: "averageLines",
      component: "AverageLine",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    crossline: {
      displayName: "Linha Cruzada",
      key: "crossline",
      icon: "Crosshair",
      propName: "crosslines",
      component: "LinhasCruzadas",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    timeCycle: {
      displayName: "Ciclos de Tempo",
      key: "timeCycle",
      icon: "Time_Cycle",
      propName: "timeCycles",
      component: "TimeCycle",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#2196F3", opacity: 0.05 },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#2196F3",
            fontSize: 11,
          },
        }),
        BooleanType({
          name: "printLevels",
          displayName: "Mostrar Números",
          defaultValue: true,
        }),
      ],
    },
  },
};

export default linhasRegistry;
